import * as Highcharts from "highcharts";
import "highcharts/highcharts-more";
import "highcharts/modules/accessibility";
import "highcharts/modules/broken-axis";
import "highcharts/modules/heatmap";
import "highcharts/modules/histogram-bellcurve";

// Highcharts 13 defaults palette.colorScheme to "light dark", which resolves its colours from the
// visitor's OS/browser scheme via light-dark().
Highcharts.setOptions({palette: {colorScheme: "light"}});

export default Highcharts;
